/**
 * Vidalga PDP — hace que, en escritorio (dispositivos con ratón real),
 * pasar el cursor por encima de una miniatura de la galería la seleccione
 * y amplíe la imagen principal, igual que si se hiciera clic.
 * En móvil/táctil no hace nada (el toque ya selecciona normalmente).
 */
(function () {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  document.addEventListener('mouseover', function (event) {
    var thumb = event.target.closest('.slideshow-controls__thumbnail');
    if (!thumb) return;
    if (thumb.getAttribute('aria-selected') === 'true') return;
    thumb.click();
  });
})();
